import { Controller } from "@hotwired/stimulus";

// Static announcement page — no interactivity of its own. Kept for this
// project's own convention of every component carrying its own controller file.
export default class extends Controller {
  connect() {}
}
